// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4950fb7","977":"3ba96267"}[chunkId] + ".chunk.js";
};